import { authenticatedFetch } from "../../../api/request";


export default async function getAllServices(idDoctorUser, setErrorMessage) {
    const onFail = () => setErrorMessage('Se produjo un error al obtener servicios.');
    const url = `/doctor-profile-management/doctor-services?idDoctorUser=${idDoctorUser}`;
    return await authenticatedFetch(url, onFail);
}